import { getSessionId, getSessionStartTime, saveCurrentStep, getAuthXToken } from '@/services/auth'
import { NR_LOGIN_PASSKEY, NR_STEPS, NR_LOGIN_STEP, EMAIL_DOMAIN_SITEMINDER } from './constants'

/**
 * Tracks login passkey step in New Relic and updates session state.
 * Records the step progression and calculates duration from session start.
 */
export const nrLoginPasskey = (): boolean => {
  try {
    const authxToken = getAuthXToken()

    if (authxToken.payload.email.includes(EMAIL_DOMAIN_SITEMINDER)) {
      return false
    }

    const sessionId = getSessionId()
    const sessionStartTime = getSessionStartTime()

    const newrelic: any = (window as any).newrelic

    // Guard against invalid session start time
    if (!sessionStartTime || isNaN(Number(sessionStartTime))) {
      return false
    }

    const duration = Date.now() - Number(sessionStartTime)


    if (newrelic && sessionId) {
      newrelic.addPageAction(NR_LOGIN_STEP, { sessionId, step: NR_STEPS.LOGIN_PASSKEY })
      newrelic.addPageAction(NR_LOGIN_PASSKEY, { sessionId, durationMs: duration })
      saveCurrentStep(NR_STEPS.LOGIN_PASSKEY)
      return true
    }

    return false
  } catch {
    return false
  }
}
